module.exports = __webpack_public_path__ + "img/1363813789.75074a9c.jpg";